var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 3C0.5 1.35938 1.8125 0 3.5 0H11V6C11 6.84375 11.6562 7.5 12.5 7.5H18.5V21C18.5 22.6875 17.1406 24 15.5 24H3.5C1.8125 24 0.5 22.6875 0.5 21V3ZM12.5 6V0L18.5 6H12.5Z",
    fill: "#8A97B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainIcon);
export default __webpack_public_path__ + "static/media/main-icon.0f39c44d39d1885bbf3570bf8e209277.svg";
export { ForwardRef as ReactComponent };